import { Banner } from '@loadsmart/miranda-react'

import { useRfpContext } from './contexts/RfpContext'

export function ErrorBanners() {
  const {
    state: { laneErrors },
  } = useRfpContext()

  return (
    <>
      {laneErrors.hasRatePerMileError && (
        <Banner variant="danger" dismissible>
          <Banner.Title>Rate per mile price can't be $0.</Banner.Title>
          <Banner.Description>
            Please increase the flat rate or a higher rate per mile price.
          </Banner.Description>
        </Banner>
      )}
      {laneErrors.hasCapacityError && (
        <Banner variant="danger" dismissible>
          <Banner.Title>One or more lanes have no capacity.</Banner.Title>
          <Banner.Description>
            Enter a minimum number, or leave the price blank if you don't want to bid on the lane.
          </Banner.Description>
        </Banner>
      )}
    </>
  )
}
